import moment from 'moment';

function normalizeOwner(owner) {
  if (!owner || !owner.id) {
    return null;
  }

  return {
    id: String(owner.id),
    given_name: owner.given_name || owner.givenName || '',
    family_name: owner.family_name || owner.familyName || '',
    email: owner.email || '',
  };
}

export function resolveTurnitinAssessmentContext(state) {
  const { turnitinReducer, userProgramsFullReducer } = state;
  const firebaseContext = turnitinReducer.submissionContext || {};
  const selectedContent = turnitinReducer.selectedContent;
  const assessmentContent = userProgramsFullReducer.assessmentContent;

  const primary = firebaseContext.survey_id
    ? firebaseContext
    : assessmentContent && assessmentContent.survey_id
      ? assessmentContent
      : selectedContent && selectedContent.survey_id
        ? selectedContent
        : {};

  const programId = primary.program_id || userProgramsFullReducer.selectedProgramId;
  const moduleId = primary.module_id || userProgramsFullReducer.selectedModuleId;
  const rolloutId = primary.rollout_id || userProgramsFullReducer.selectedRolloutId;

  let programName = primary.program_name || primary.programName;
  let moduleName = primary.module_name || primary.moduleName;
  const groupContextOwners = (
    primary.group_context_owners
    || primary.groupContextOwners
    || primary.instructors
    || []
  ).map(normalizeOwner).filter(Boolean);

  const programs = userProgramsFullReducer.programs && userProgramsFullReducer.programs.programs;

  if (programs && programId) {
    const program = programs.find(
      item => String(item.programId) === String(programId),
    );

    if (program) {
      programName = programName || program.name;

      if (moduleId && Array.isArray(program.modules)) {
        const module = program.modules.find(
          item => String(item.moduleId) === String(moduleId),
        );

        if (module) {
          moduleName = moduleName || module.name;
        }
      }
    }
  }

  return {
    survey_id: primary.survey_id || userProgramsFullReducer.selectedAssessmentId,
    module_id: moduleId,
    program_id: programId,
    rollout_id: rolloutId,
    name: primary.name || primary.title || (assessmentContent && assessmentContent.name) || (selectedContent && selectedContent.name),
    moduleName,
    programName,
    groupContextName: moduleName || programName || primary.group_context_name || 'Course',
    groupContextOwners,
  };
}

export function buildTurnitinEulaAcceptPayload({
  userId,
  version,
  language = 'en-US',
  acceptedTimestamp,
}) {
  return {
    user_id: String(userId),
    version,
    language,
    accepted_timestamp: acceptedTimestamp,
  };
}

export function buildTurnitinSubmissionPayload({ user, assessmentContext, request_id, eula }) {
  const personMetadata = {
    id: String(user.userId),
    given_name: user.firstName,
    family_name: user.lastName,
    email: user.email,
  };

  const metadata = {
    owners: [personMetadata],
    submitter: personMetadata,
    original_submitted_time: moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
    custom: JSON.stringify({
      Type: 'Free Text',
      request_id,
      user_id: user.userId,
      survey_id: assessmentContext.survey_id,
      module_id: assessmentContext.module_id,
      program_id: assessmentContext.program_id,
      rollout_id: assessmentContext.rollout_id,
    }),
  };

  if (assessmentContext.survey_id && assessmentContext.module_id) {
    metadata.group = {
      id: `${assessmentContext.survey_id}-${assessmentContext.module_id}-${assessmentContext.rollout_id || '0'}`,
      name: assessmentContext.name || 'Assessment',
      type: 'ASSIGNMENT',
    };
  }

  if (assessmentContext.program_id && assessmentContext.module_id) {
    metadata.group_context = {
      id: `${assessmentContext.program_id}-${assessmentContext.module_id}`,
      name: assessmentContext.groupContextName,
    };

    if (assessmentContext.groupContextOwners.length > 0) {
      metadata.group_context.owners = assessmentContext.groupContextOwners;
    }
  }

  const payload = {
    owner: String(user.userId),
    submitter: String(user.userId),
    title: assessmentContext.name || 'Assessment',
    owner_default_permission_set: 'LEARNER',
    submitter_default_permission_set: 'LEARNER',
    extract_text_only: false,
    metadata,
  };

  if (eula && eula.version && eula.accepted_timestamp) {
    payload.eula = {
      version: eula.version,
      language: eula.language || 'en-US',
      accepted_timestamp: eula.accepted_timestamp,
    };
  }

  return payload;
}
